import axios from 'axios';
import {apiConfig} from '../../config';

// `timeout` est indispensable : sans lui une requête qui ne répond jamais (API figée,
// dépendance en panne…) laisse sa promesse en suspens indéfiniment, ce qui bloque
// l'overlay de chargement global et toute logique qui l'attend.
const REQUEST_TIMEOUT_MS = 30000;

export default axios.create({
  baseURL: apiConfig.baseURL,
  timeout: REQUEST_TIMEOUT_MS,
  timeoutErrorMessage:
    "Le serveur n'a pas répondu dans le délai imparti. Vérifiez votre connexion puis réessayez.",
  headers: {
    'Content-Type': 'application/json',
  },
});
